export const selectItemHeight = 51
export const actionsSelectMenuMaxHeight = 255
export const actionsSelectSmallMenuMaxHeight = 200
